import { render, staticRenderFns } from "./FloatBox.vue?vue&type=template&id=3bd20a76&"
import script from "./FloatBox.vue?vue&type=script&lang=js&"
export * from "./FloatBox.vue?vue&type=script&lang=js&"
import style0 from "./FloatBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports